import dayjs from 'dayjs'
import layout from '@/layout'
const meta = { auth: true }

export default {
  path: '/expo',
  component: layout,
  children: ((pre) => [
    {
      path: 'info',
      name: `${pre}info`,
      meta: {
        ...meta,
        cache: true,
        title: '展会信息维护',
        head: true,
        funcID: 'T001001',
        PID: 'T00',
      },
      component: () => import('@/views/digital/expo/info'),
    },
    {
      path: 'choiceSample',
      name: `${pre}choiceSample`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'T001002',
        PID: 'T00',
      },
      component: () => import('@/views/digital/expo/choiceSample'),
    },
    {
      path: 'meetingSet',
      name: `${pre}meetingSet`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'T001003',
        PID: 'T00',
      },
      component: () => import('@/views/digital/expo/meetingSet'),
    },
    {
      path: 'meetingSet/:expoMeetingCode/:expoInfoCode?',
      name: `${pre}meetingSet-detail`,
      meta: {
        ...meta,
        cache: true,
        title: ({ $route }) => {
          const { custName, meetingDate } = $route.query || {}
          const date = meetingDate ? dayjs(meetingDate).format('MM/DD') : ''
          const title = [custName, date].filter(Boolean).join(' ')
          return `展会会议安排 | ${title}`
        },
        funcID: 'T001003',
        PID: 'T00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0' },
          body: { class: 'pt-0 mb-0' },
        },
      },
      component: () => import('@/views/digital/expo/meetingSet/detail'),
    },
  ])('expo-'),
}
